import { ADD_MENU } from "../Actions/Utilites";


const INITIAL_STATE = {
  // Add Menu
  addMenuLoading: false,
  addMenuSuccess: false,
  addMenuFailure: false,
  addMenuError: null,

  //   Get ALl Menu
  getAllMenuLoading: false,
  getAllMenuSuccess: false,
  getAllMenuFailure: false,
  getAllMenuError: null,
  getAllMenu: [],

  //   Get Menu
  getMenuLoading: false,
  getMenuSuccess: false,
  getMenuFailure: false,
  getMenuError: null,
  getMenu: [],

  //   Update Menu
  updateMenuLoading: false,
  updateMenuSuccess: false,
  updateMenuFailure: false,
  updateMenuError: null,
  updateMenu: [],

  //   Delete Menu
  deleteMenuLoading: false,
  deleteMenuSuccess: false,
  deleteMenuFailure: false,
  deleteMenuError: null,
  deleteMenu: [],
};

export const MenuReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Add Menu
    case ADD_MENU.ADD_MENU_REQUEST:
      return {
        ...state,
        addMenuLoading: true,
        addMenuSuccess: false,
        addMenuFailure: false,
        addMenuError: null,
      };
    case ADD_MENU.ADD_MENU_SUCCESS:
      return {
        ...state,
        addMenuLoading: false,
        addMenuSuccess: true,
        addMenuFailure: false,
        addMenuError: null,
        getAllMenu: [...state.getAllMenu, action.payload.result],
      };
    case ADD_MENU.ADD_MENU_FAILURE:
      return {
        ...state,
        addMenuLoading: false,
        addMenuSuccess: false,
        addMenuFailure: true,
        addMenuError: action.payload,
      };

    //   Get All Menu
    case ADD_MENU.GET_ALL_MENU_REQUEST:
      return {
        ...state,
        getAllMenuLoading: true,
        getAllMenuSuccess: false,
        getAllMenuFailure: false,
        getAllMenuError: null,
      };
    case ADD_MENU.GET_ALL_MENU_SUCCESS:
      return {
        ...state,
        getAllMenuLoading: false,
        getAllMenuSuccess: true,
        getAllMenuFailure: false,
        addAllMenuError: null,
        getAllMenu: action.payload.result,
      };
    case ADD_MENU.GET_ALL_MENU_FAILURE:
      return {
        ...state,
        getAllMenuLoading: false,
        getAllMenuSuccess: false,
        getAllMenuFailure: true,
        getAllMenuError: action.payload,
      };

    // Get Menu
    case ADD_MENU.GET_MENU_REQUEST:
      return {
        ...state,
        getMenuLoading: true,
        getMenuSuccess: false,
        getMenuFailure: false,
        getMenuError: null,
      };
    case ADD_MENU.GET_MENU_SUCCESS:
      return {
        ...state,
        getMenuLoading: false,
        getMenuSuccess: true,
        getMenuFailure: false,
        addMenuError: null,
        getMenu: action.payload.result,
      };
    case ADD_MENU.GET_MENU_FAILURE:
      return {
        ...state,
        getMenuLoading: false,
        getMenuSuccess: false,
        getMenuFailure: true,
        getMenuError: action.payload,
      };

    // Update Note
    case ADD_MENU.UPDATE_MENU_REQUEST:
      return {
        ...state,
        updateMenuLoading: true,
        updateMenuSuccess: false,
        updateMenuFailure: false,
        updateMenuError: null,
      };
    case ADD_MENU.UPDATE_MENU_SUCCESS:
      return {
        ...state,
        updateMenuLoading: false,
        updateMenuSuccess: true,
        updateMenuFailure: false,
        updateMenuError: null,
        updateMenu: action.payload,
      };
    case ADD_MENU.UPDATE_MENU_FAILURE:
      return {
        ...state,
        updateMenuLoading: false,
        updateMenuSuccess: false,
        updateMenuFailure: true,
        updateMenuError: action.payload,
      };

    // Delete Note
    case ADD_MENU.DELETE_MENU_REQUEST:
      return {
        ...state,
        deleteMenuLoading: true,
        deleteMenuSuccess: false,
        deleteMenuFailure: false,
        deleteMenuError: null,
      };
    case ADD_MENU.DELETE_MENU_SUCCESS:
      const result = state.getAllMenu.filter(
        (note) => note.id !== action.payload.result
      );
      return {
        ...state,
        deleteMenuLoading: false,
        deleteMenuSuccess: true,
        deleteMenuFailure: false,
        deleteMenuError: null,
        getAllMenu: result,
      };
    case ADD_MENU.DELETE_MENU_FAILURE:
      return {
        ...state,
        deleteMenuLoading: false,
        deleteMenuSuccess: false,
        deleteMenuFailure: true,
        deleteMenuError: action.payload,
      };

    default:
      return state;
  }
};
